module.exports = __webpack_public_path__ + "img/support.69b4aab0.svg";